/**
 * WhatsApp-style inline markup: *bold*, **bold**, _italic_, ~strike~, ```code```
 */

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/**
 * Convert WhatsApp markup in plain text to safe HTML for preview bubbles.
 */
export function formatWhatsAppMarkupToHtml(text) {
  if (!text) return "";

  let html = escapeHtml(text);

  html = html
    .replace(
      /```([\s\S]*?)```/g,
      "<code class='text-[11px] bg-gray-100 px-0.5 rounded font-mono'>$1</code>"
    )
    .replace(/\*\*([^*\n]+)\*\*/g, "<strong>$1</strong>")
    .replace(/\*([^*\n]+)\*/g, "<strong>$1</strong>")
    .replace(/_([^_\n]+)_/g, "<em>$1</em>")
    .replace(/~([^~\n]+)~/g, "<s>$1</s>")
    .replace(/\n/g, "<br/>");

  return html;
}
